import React, { useState, useEffect } from "react";
import { _get, _post } from '../ApiModule/ApiClient';
import Select from "react-select";
import './Lesson.css';

function Lesson() {
    const [lessons, setLessons] = useState([]);
    const [transcriptOpts, setTranscriptOpts] = useState([]);
    const [selectedTrans, setSelectedTrans] = useState([]);
    const [newLesson, setNewLesson] = useState("");

    const renderLessonList = () => {
        if(lessons) {
            return lessons.map((item) => {
                return <li key={item.guid}>{item.lessonName}</li>
            })
        }
    };

    const handleTranscriptChange = (transcript) => {
        setSelectedTrans(transcript);
    };

    const fetchLessons = async () => {
        try {
            const response = await _get('/api/lessons');
            const data = await response.json();
            setLessons(data.lessons);
        } catch (error) {
            console.error('Error fetching data:', error);
            // Handle errors
        }
    };

    const submitLesson = (event) => {
        event.preventDefault();
        let lesson = {};
        lesson.lessonName = newLesson;
        lesson.transcriptions = selectedTrans.map(t => {return { guid: t.value, lessonName: newLesson}});
        _post('/api/lessons', lesson);
    };

    const fetchTranscriptions = async () => {
        try {
            const response = await _get('/api/transcriptions?filter=true');
            const data = await response.json();
            setTranscriptOpts(data.map(t => {
                let opt = {};
                opt.value = t.guid;
                opt.label = t.guid;
                return opt;
            }));
        } catch (error) {
            console.error('Error fetching data:', error);
            // Handle errors
        }
    };

    useEffect(() => {
        fetchLessons();
        fetchTranscriptions();
    }, []);

    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <form onSubmit={submitLesson}>
                        <div className="form-group row">
                            <label htmlFor="lesson-name-input">Name</label>
                            <div className="col-sm-4">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="lesson-name-input"
                                    value={newLesson}
                                    onChange={(e) => setNewLesson(e.target.value)}
                                    placeholder="Example Lesson" />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="transcript-select">Transcripts</label>
                            <div className="col-sm-4">
                                <Select
                                    options={transcriptOpts}
                                    value={selectedTrans}
                                    onChange={handleTranscriptChange}
                                    isMulti={true}
                                    closeMenuOnSelect={false}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                                <button type="submit" className="btn btn-outline-primary">Add</button>
                                <button type="button" className="btn btn-outline-danger">Remove</button>
                        </div>
                    </form>
                    <ul className="list-group">
                        {renderLessonList()}
                    </ul>
                </div>
                <div className="col">
                    <ul className="list-group">

                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Lesson;
